import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import { Title } from "./GlobalMassssage";
import Footer from "./Footer";

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  let title = "JobMongo";

  // Check if the current route is "/login" or "/logout"
  const isLoginPage =
    location.pathname === "/login" || location.pathname === "/logout";

  // Set dynamic page title
  switch (location.pathname) {
    case "/":
      title = "Dashboard | " + Title;
      break;
    case "/login":
      title = "Login | " + Title;
      break;
    case "/customer":
      title = "Customer | " + Title;
      break;
    case "/report":
      title = "Reports | " + Title;
      break;
    case "/configure":
      title = "Configure | " + Title;
      break;
    case "/subscriptions":
      title = "Subscriptions | " + Title;
      break;
    case "/Setting":
    case "/setting":
      title = "Setting | " + Title;
      break;
    case "/AddUpdateCustomer":
      title = "Add-Update-Customer | " + Title;
      break;
    case "/service-job-type":
      title = "Service-Job-Type | " + Title;
      break;
  }

  document.title = title;

  useEffect(() => {
    const allowedPaths = [
      "/service-job-type",
      "/configure",
      "/addupdateChecklist",
    ];

    if (
      location.pathname !== localStorage.getItem("CurrentPath") &&
      !allowedPaths.includes(location.pathname)
    ) {
      localStorage.removeItem("selectedTab");
      localStorage.removeItem("CurrentPath");
    }
  }, [location.pathname]);

  useEffect(() => {
    const storedAuth = JSON.parse(localStorage.getItem("login"));
    if (!storedAuth) {
      navigate("/login");
    }
  }, []);

  return (
    <div className="min-h-screen bg-white-100 flex flex-col">
      {/* Render Navbar only if not on login page */}
      {!isLoginPage && <Navbar />}

      <main
        className={`flex-grow mx-auto px-1 py-1 w-full ${
          isLoginPage ? "flex items-center justify-center" : ""
        }`}
      >
        {children}
      </main>

      {/* Render Footer only if not on login page */}
      {!isLoginPage && <Footer />}
    </div>
  );
};

export default Layout;
